import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RightPopupComponent } from './right-popup.component';

@NgModule({
  declarations: [RightPopupComponent],
  exports: [RightPopupComponent],
  imports: [CommonModule],
})
export class RightPopupModule {}
